import moment from 'moment';
import { IListColumn } from '~/models/listCol';
import { cpfMask, phoneMask } from '~/utils/masks';

export const HeaderProposalsRegistered = [
  {
    id: 1,
    value: 'Nome completo',
    maxChar: 20,
  },
  {
    id: 2,
    value: 'CPF',
    maxChar: 15,
    textAlign: 'center',
  },
  {
    id: 3,
    value: 'Celular',
    maxChar: 15,
    textAlign: 'center',
  },
  {
    id: 4,
    value: 'Operador(a) de Venda',
    maxChar: 20,
  },
  {
    id: 5,
    value: 'Origem',
    maxChar: 11,
    textAlign: 'center',
  },
  {
    id: 6,
    value: 'Data Proposta',
    maxChar: 20,
    textAlign: 'center',
  },
  {
    id: 7,
    value: 'Data Aprovação',
    maxChar: 20,
    textAlign: 'center',
  },
  {
    id: 8,
    value: 'Nacionalidade',
    maxChar: 20,
    textAlign: 'center',
  },
  {
    id: 9,
    value: 'UF',
    maxChar: 8,
    textAlign: 'center',
  },
  {
    id: 10,
    value: 'FaceDoc',
    maxChar: 9,
    textAlign: 'center',
  },
];

export const BodyProposalsRegistered = (data: any) => {
  // let x = 0;

  const items = [];

  data.pagina?.forEach((i) => {
    const item: IListColumn[] = [
      // {
      //   type: 'id',
      //   value: x++,
      //   maxChar: 5,
      // },
      {
        value: i.nome,
        maxChar: 20,
      },
      {
        value: cpfMask(i.cpf).masked,
        maxChar: 15,
        textAlign: 'center',
      },
      {
        value: phoneMask(i.celular).masked,
        maxChar: 15,
        textAlign: 'center',
      },
      {
        value: i.operador,
        maxChar: 20,
      },
      {
        value: i.origem,
        maxChar: 11,
        textAlign: 'center',
      },
      {
        value: i.dataProposta
          ? moment(i.dataProposta).format('DD/MM/YYYY HH:mm')
          : '-',
        maxChar: 20,
        textAlign: 'center',
      },
      {
        value: i.dataAprovacao
          ? moment(i.dataAprovacao).format('DD/MM/YYYY HH:mm')
          : '-',
        maxChar: 20,
        textAlign: 'center',
      },
      {
        value: i.nacionalidade,
        maxChar: 20,
        textAlign: 'center',
      },
      {
        value: i.uf,
        maxChar: 8,
        textAlign: 'center',
      },
      {
        value: i.forceFaceMatch
          ? 'Ignorado'
          : i.faceMatchCheckResponse?.status
            ? i.faceMatchCheckResponse.status.charAt(0).toUpperCase() +
            i.faceMatchCheckResponse.status.slice(1).toLowerCase()
            : '-',
        maxChar: 9,
        textAlign: 'center',
      },
    ];
    items.push(item);
  });
  return items;
};

export const BodyProposalsRegisteredCSV = (data: any) => {
  const dataCSV = [];

  data.pagina?.forEach((i) => {
    dataCSV.push({
      ...i,
      faceDoc: i.forceFaceMatch
        ? 'Ignorado'
        : i.faceMatchCheckResponse?.status
          ? i.faceMatchCheckResponse.status.charAt(0).toUpperCase() +
          i.faceMatchCheckResponse.status.slice(1).toLowerCase()
          : '-',
    });
  });

  return dataCSV;
};
